import React from 'react';
import { Modifier } from 'react-day-picker/types/Modifiers';
import { Control, RegisterOptions, useController } from 'react-hook-form';
import { startOfDay } from 'date-fns';
import { DATE_PLACEHOLDER } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import {
  DatePickerInput,
  IDatePickerInputProps,
} from 'src/components/DatePickerInput/DatePickerInput';

export type DateInputProps = {
  control: Control;
  rules?: RegisterOptions;
  disabledDays?: Modifier | Modifier[];
  initialMonth?: Date;
} & Omit<
  IDatePickerInputProps,
  | 'onDateChange'
  | 'dayPickerProps'
  | 'initialDate'
  | 'placeholder'
  | 'numberOfConsecutiveDays'
  | 'useFullScreenOverlay'
  | 'forceMonthsToWrap'
  | 'chooseConsecutiveDays'
  | 'initialDateRange'
>;

export const DATE_PICKER_DATE_FORMAT = 'eee MMM dd yyyy';

export const DateInput = ({
  control,
  rules = {},
  name,
  error,
  disabledDays,
  initialMonth,
  disabled = false,
  blockWidth = false,
  ...rest
}: DateInputProps): JSX.Element => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? '',
  });

  return (
    <DatePickerInput
      {...rest}
      name={name}
      error={error}
      disabled={disabled}
      blockWidth={blockWidth}
      forceMonthsToWrap
      initialDate={value}
      dayPickerProps={{
        ...(disabledDays && { disabledDays }),
        ...(initialMonth && { month: initialMonth }),
        numberOfMonths: 1,
      }}
      numberOfConsecutiveDays={1}
      useFullScreenOverlay
      placeholder={DATE_PLACEHOLDER}
      onDateChange={(value: Date): void => {
        onChange(startOfDay(value));
      }}
    />
  );
};
